/// <reference types="bun-types" />
/// <reference lib="dom" />
/// <reference lib="dom.iterable" />

import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin.js";
import * as PIXI from "pixi.js";

import HeatMapElement from "./src/HeatMapElement";
import AvalancheElement from "./src/AvalancheElement";
import HashMapElement from "./src/HashMapElement";

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);

gsap.ticker.add(() => {
  if (gsap.globalTimeline.getChildren().length === 0) {
    gsap.ticker.sleep();
  }
});

async function main() {
  HeatMapElement.register();
  HashMapElement.register();
  AvalancheElement.register();

  const msg = `
Hello! 👋

Thank you for taking an interest in how this post works. This was my first post
that used TypeScript, and as a result the code is minified. I do, however,
publish source maps for the code so you should still be able to poke around at
it in your browser.

If you would prefer, though, the code is open sourced at
https://github.com/samwho/visualisations. If you have any questions or feedback,
please feel free to open an issue!
    `;
  console.log(msg);
}

document.addEventListener("DOMContentLoaded", () => {
  main();
});
